import { render, staticRenderFns } from "./TaxonomyWrapper.vue?vue&type=template&id=700c9517&scoped=true&"
import script from "./TaxonomyWrapper.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700c9517",
  null
  
)

export default component.exports